import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';

export default function DetailRow({ label, value, valueNode }) {
  return (
    <Stack direction="row" justifyContent="space-between" spacing={2} alignItems="flex-start">
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      {valueNode || (
        <Typography variant="body2" fontWeight={600} textAlign="right">
          {value || 'N/A'}
        </Typography>
      )}
    </Stack>
  );
}

DetailRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueNode: PropTypes.node,
};
